import * as actionTypes from "../action-types";

//! Admin
export const getAdmins = payload => ({ type: actionTypes.GET_ADMINS, payload });
export const getAdminById = payload => ({ type: actionTypes.GET_ADMIN_BY_ID, payload });
export const createAdmin = payload => ({ type: actionTypes.CREATE_ADMIN, payload });
export const updateAdmin = payload => ({ type: actionTypes.UPDATE_ADMIN, payload });
export const deleteAdmin = payload => ({ type: actionTypes.DELETE_ADMIN, payload });

//* Partner
export const getPartnerByAdminId = payload => ({ type: actionTypes.GET_PARTNER_BY_ADMINID, payload });
export const setPartnerByAdminId = payload => ({ type: actionTypes.SET_PARTNER_BY_ADMINID, payload });

//* Partner Bank Detail
export const getPartnerBankDetails = payload => ({ type: actionTypes.GET_PARTNER_BANK_DETAILS, payload });
export const getActivePartnerBankDetail = payload => ({ type: actionTypes.GET_ACTIVE_PARTNER_BANK_DETAIL, payload });
export const createPartnerBankDetail = payload => ({ type: actionTypes.CREATE_PARTNER_BANK_DETAIL, payload });
export const updatePartnerBankDetail = payload => ({ type: actionTypes.UPDATE_PARTNER_BANK_DETAIL, payload });
export const deletePartnerBankDetail = payload => ({ type: actionTypes.DELETE_PARTNER_BANK_DETAIL, payload });
export const changePartnerBankDetailStatus = payload => ({ type: actionTypes.CHANGE_PARTNER_BANK_DETAIL_STATUS, payload });

//! Admin Report Wallet
export const getAdminReportWallets = payload => ({ type: actionTypes.GET_ADMIN_REPORT_WALLETS, payload });
export const createAdminReportWallet = payload => ({ type: actionTypes.CREATE_ADMIN_REPORT_WALLET, payload });
export const updateAdminReportWallet = payload => ({ type: actionTypes.UPDATE_ADMIN_REPORT_WALLET, payload });
export const deleteAdminReportWallet = payload => ({ type: actionTypes.DELETE_ADMIN_REPORT_WALLET, payload });

//! Registration Number
export const getRegistrationNumbers = payload => ({ type: actionTypes.GET_REGISTRATION_NUMBERS, payload });
export const createRegistrationNumber = payload => ({ type: actionTypes.CREATE_REGISTRATION_NUMBER, payload });
export const updateRegistrationNumber = payload => ({ type: actionTypes.UPDATE_REGISTRATION_NUMBER, payload });
export const deleteRegistrationNumber = payload => ({ type: actionTypes.DELETE_REGISTRATION_NUMBER, payload });

//! Video: Tutorials & Business
export const getVideos = payload => ({ type: actionTypes.GET_VIDEOS, payload });
export const createVideo = payload => ({ type: actionTypes.CREATE_VIDEO, payload });
export const updateVideo = payload => ({ type: actionTypes.UPDATE_VIDEO, payload });
export const deleteVideo = payload => ({ type: actionTypes.DELETE_VIDEO, payload });
export const changeVideoStatus = payload => ({ type: actionTypes.CHANGE_VIDEO_STATUS, payload });

//! Blog
export const getBlogs = payload => ({ type: actionTypes.GET_BLOGS, payload });
export const getBlogById = payload => ({ type: actionTypes.GET_BLOG_BY_ID, payload });
export const createBlog = payload => ({ type: actionTypes.CREATE_BLOG, payload });
export const updateBlog = payload => ({ type: actionTypes.UPDATE_BLOG, payload });
export const deleteBlog = payload => ({ type: actionTypes.DELETE_BLOG, payload });

//! Coupon
export const getCoupons = payload => ({ type: actionTypes.GET_COUPONS, payload });
export const createCoupon = payload => ({ type: actionTypes.CREATE_COUPON, payload });
export const updateCoupon = payload => ({ type: actionTypes.UPDATE_COUPON, payload });
export const deleteCoupon = payload => ({ type: actionTypes.DELETE_COUPON, payload });

//! Reports
export const getReportModules = payload => ({ type: actionTypes.GET_REPORT_MODULES, payload });
export const getReports = payload => ({ type: actionTypes.GET_REPORTS, payload });
export const createReport = payload => ({ type: actionTypes.CREATE_REPORT, payload });
export const updateReport = payload => ({ type: actionTypes.UPDATE_REPORT, payload });
export const deleteReport = payload => ({ type: actionTypes.DELETE_REPORT, payload });

export const getGeneratedReports = payload => ({ type: actionTypes.GET_GENERATED_REPORTS, payload });
export const setGeneratedReports = payload => ({ type: actionTypes.SET_GENERATED_REPORTS, payload });
export const getCustomersAll = payload => ({ type: actionTypes.GET_CUSTOMERS_ALL, payload });
export const setCustomersAll = payload => ({ type: actionTypes.SET_CUSTOMERS_ALL, payload });

//! Static Page
export const createUpdateStaticPage = payload => ({ type: actionTypes.CREATE_UPDATE_STATIC_PAGE, payload });

export const getTermsOfUse = payload => ({ type: actionTypes.GET_TERMS_OF_USE, payload });
export const setTermsOfUse = payload => ({ type: actionTypes.SET_TERMS_OF_USE, payload });

export const getPrivacyPolicy = payload => ({ type: actionTypes.GET_PRIVACY_POLICY, payload });
export const setPrivacyPolicy = payload => ({ type: actionTypes.SET_PRIVACY_POLICY, payload });

export const getShippingPolicy = payload => ({ type: actionTypes.GET_SHIPPING_POLICY, payload });
export const setShippingPolicy = payload => ({ type: actionTypes.SET_SHIPPING_POLICY, payload });

export const getRefundPolicy = payload => ({ type: actionTypes.GET_REFUND_POLICY, payload });
export const setRefundPolicy = payload => ({ type: actionTypes.SET_REFUND_POLICY, payload });

export const getAboutUs = payload => ({ type: actionTypes.GET_ABOUT_US, payload });
export const setAboutUs = payload => ({ type: actionTypes.SET_ABOUT_US, payload });

//! Site Settings
export const getSiteSettings = payload => ({ type: actionTypes.GET_SITE_SETTINGS, payload });
export const createUpdateSiteSettings = payload => ({ type: actionTypes.CREATE_UPDATE_SITE_SETTINGS, payload });

//! Awards
export const getAwards = payload => ({ type: actionTypes.GET_AWARDS, payload });
export const createAward = payload => ({ type: actionTypes.CREATE_AWARD, payload });
export const updateAward = payload => ({ type: actionTypes.UPDATE_AWARD, payload });
export const deleteAward = payload => ({ type: actionTypes.DELETE_AWARD, payload });
export const changeAwardStatus = payload => ({ type: actionTypes.CHANGE_AWARD_STATUS, payload });

//! Media Coverage
export const getMediaCoverage = payload => ({ type: actionTypes.GET_MEDIA_COVERAGE, payload });
export const createMediaCoverage = payload => ({ type: actionTypes.CREATE_MEDIA_COVERAGE, payload });
export const updateMediaCoverage = payload => ({ type: actionTypes.UPDATE_MEDIA_COVERAGE, payload });
export const deleteMediaCoverage = payload => ({ type: actionTypes.DELETE_MEDIA_COVERAGE, payload });
export const changeMediaCoverageStatus = payload => ({ type: actionTypes.CHANGE_MEDIA_COVERAGE_STATUS, payload });

//! Testimonial Videos
export const getTestimonialVideos = payload => ({ type: actionTypes.GET_TESTIMONIAL_VIDEOS, payload });

//! Bug Tracker
export const getBugReports = payload => ({ type: actionTypes.GET_BUG_REPORTS, payload });
export const setBugReports = payload => ({ type: actionTypes.SET_BUG_REPORTS, payload });
export const getBugReportById = payload => ({ type: actionTypes.GET_BUG_REPORT_BY_ID, payload });
export const setBugReportById = payload => ({ type: actionTypes.SET_BUG_REPORT_BY_ID, payload });
export const createBugReport = payload => ({ type: actionTypes.CREATE_BUG_REPORT, payload });
export const updateBugReport = payload => ({ type: actionTypes.UPDATE_BUG_REPORT, payload });
export const updateBugStatus = payload => ({ type: actionTypes.UPDATE_BUG_STATUS, payload });
export const addBugComment = payload => ({ type: actionTypes.ADD_BUG_COMMENT, payload });
export const addBugResolution = payload => ({ type: actionTypes.ADD_BUG_RESOLUTION, payload });
export const addBugTestReport = payload => ({ type: actionTypes.ADD_BUG_TEST_REPORT, payload });
export const deleteBugReport = payload => ({ type: actionTypes.DELETE_BUG_REPORT, payload });
export const getBugStats = payload => ({ type: actionTypes.GET_BUG_STATS, payload });
export const setBugStats = payload => ({ type: actionTypes.SET_BUG_STATS, payload });
export const searchBugReports = payload => ({ type: actionTypes.SEARCH_BUG_REPORTS, payload });
export const setSearchBugReports = payload => ({ type: actionTypes.SET_SEARCH_BUG_REPORTS, payload });